module.exports = __webpack_public_path__ + "static/media/profileCircleNFG.de00d3f0.svg";